import React from 'react';
import CalculusOfEndurance from '../components/CalculusOfEndurance';

function CalculusOfEndurancePage() {
  return <CalculusOfEndurance />;
}

export default CalculusOfEndurancePage;
